export default {
    DetailsOfThirdPartyAfterSalesOrder: {
        Details: '三方售后单详情',
        Normal: '正常流转',
        The: '三方售后单已成功转单内部售后订单进行处理',
        Suspend: '暂停流转',
        Reason: '原因：',
        Basic: '基础信息',
        Store: '店铺名称',
        After: '售后类型',
        Platform: '平台状态',
        sales: '售后原因',
        remarks: '售后备注',
        Buyer: '买家信息',
        nickname: '买家昵称',
        Return: '退货快递',
        Refund: '退款物流单号',
        Original: '原收件地址',
        Exchange: '换货收件人',
        recipient: '换货收件手机',
        address: '换货收件地址',
        Associated: '关联单据',
        Third: '三方售后单号',
        party: '原客户订单号',
        Internal: '内部售后单号',
        order: '内部原订单号',
        number: '平台换货单号',
        time: '订单时间',
        Application: '申请售后时间',
        completion: '售后完成时间',
        Timeout: '超时时间',
        Creation: '创建时间',
        products: '售后商品明细',
        item: '换货商品明细',
        form: {
            Original: '原始子订单号',
            Product: '商品数量',
            System: '系统商品编码',
            SKU: '系统SKU编码',
            Comment: '备注',
            ID: '平台货品ID',
            code: '平台货品编码',
            PlatformID: '平台规格ID',
            Platformcode: '平台规格编码',
            productname: '平台商品名称',
            Unit: '商品单价',
            amount: '交易金额',
            Refund: '退款金额',

            note: '换货单号',
            item: '换货货品ID',
            itemcode: '换货货品编码',
            ExchangeID: '换货规格ID',
            Exchangecode: '换货规格编码',
            Exchangename: '换货商品名称',
            price: '换货商品单价',
        }
    }
};
